import "./Faq.css";
import { IoChevronDown } from "react-icons/io5";
import { useEffect, useState } from "react";
import Question from "./question";

const Faq = () => {
  const faq = [
    {
      question: "What is the training about?",
      answer:
        "Our training programs are designed to equip learners with practical, industry-relevant technology skills through hands-on learning, mentorship, real-world projects, and career support. Depending on the cohort you join, training may cover areas such as Data Analytics, Data Science, Artificial Intelligence, Machine Learning, Web Development, Robotics, Cloud Computing, Cybersecurity, Product Design, and other emerging technology fields.",
    },
    {
      question: "Who can apply for the training?",
      answer:
        "Anyone with an interest in technology and digital skills can apply. Our programs are designed for students, graduates, working professionals, entrepreneurs, career switchers, and beginners looking to start a career in tech.",
    },
    {
      question: "Do I need prior experience?",
      answer:
        "No. Most of our programs are beginner-friendly and start with foundational concepts before progressing to more advanced topics. Some specialized tracks may have prerequisites, which will be clearly stated during registration.",
    },
    {
      question: "Is the training online or physical?",
      answer:
        "Training may be delivered virtually, physically, or in a hybrid format depending on the specific program. Details for each cohort will be communicated before classes begin.",
    },
    {
      question: "Will I receive a certificate?",
      answer:
        "Yes. Participants who meet attendance requirements and successfully complete the program requirements will receive a certificate of completion.",
    },
    {
      question: "Are there practical projects?",
      answer:
        "Yes. We emphasize project-based learning. Participants work on practical assignments, case studies, and real-world projects to build experience and strengthen their portfolios.",
    },
    {
      question: "What tools and software will I learn?",
      answer:
        "The tools vary by program. Depending on your track, you may learn industry-standard technologies such as Excel, Power BI, SQL, Python, AI tools, cloud platforms, web development frameworks, design software, and other relevant technologies.",
    },
    {
      question: "How long does the training last?",
      answer:
        "The duration varies by program and cohort. Training schedules and timelines will be provided on the registration page for each program.",
    },
    {
      question: "Will there be mentorship?",
      answer:
        "Yes. Participants have access to experienced instructors, mentors, and industry professionals who provide guidance throughout the learning journey.",
    },
  ];

  const [open, setOpen] = useState([]);
  const [mobile, setMobile] = useState(false);

  const handleToggle = (i) => {
    setOpen((prevOpen) => {
      const newOpen = [...prevOpen];
      newOpen[i] = !newOpen[i];
      return newOpen;
    });
  };

  useEffect(() => {
    if (window.innerWidth <= 768) {
      setMobile(true);
    }
  }, []);

  return (
    <div className="faq-container">
      <Question
        style={{
          position: "absolute",
          top: "14%",
          left: "70%",
          transform: "translate(-50%, -10%)",
          rotate: "45deg",
          transformOrigin: "center",
        }}
        size={"25rem"}
      />

      {!mobile && (
        <Question
          size={"15rem"}
          style={{
            position: "absolute",
            top: "14%",
            left: "60%",
            transform: "translate(-50%, -20%)",
            rotate: "45deg",
            transformOrigin: "center",
          }}
        />
      )}

      <div className="faq-header">
        <h1>Frequently Asked Questions</h1>
        <p className="sub">
          Find quick answers to common questions about our training programs below.
        </p>
      </div>

      <ul>
        {faq.map((item, i) => (
          <li key={i} onClick={() => handleToggle(i)}>
            <h3>
              {item.question}{" "}
              <span onClick={() => handleToggle(i)}>
                <IoChevronDown
                  className={open[i] ? "svg-rotate" : "svg-normal"}
                />
              </span>
            </h3>

            <p className={open[i] ? "down" : ""}>
              {item.answer}
            </p>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Faq;

